import { ItemsPerPageType } from '@uag/react-core';

import { ApiResponseMetadata } from 'api/v3/models';

type PagedItem = {
    metadata?: ApiResponseMetadata | null;
};

export const getTotalPages = (
    itemsPerPage: ItemsPerPageType,
    items?: PagedItem,
    searchItems?: PagedItem,
    searchValue?: string,
) => {
    const totalCount =
        searchValue && searchItems ? searchItems?.metadata?.paging?.totalCount : items?.metadata?.paging?.totalCount;
    return Math.ceil((totalCount ?? 1) / itemsPerPage);
};
